import React, { useRef, useState } from "react";
import { Container,Row, Col } from "react-bootstrap";
import SmartOptionsWelcome from "./SmartOptionsWelcome/SmartOptionsWelcome";
import SmartOptionsHowItWorks from "./SmartOptionsHowItWorks/SmartOptionsHowItWorks";
import SmartOptionsOneStopSolution from "./SmartOptionsOneStopSolution/SmartOptionsOneStopSolution";
import SmartOptionsCompleteIndex from "./SmartOptionsCompleteIndex/SmartOptionsCompleteIndex"
import congratulation from "./../../Images/congratulation-img.png";
import SmartOptionsDepthanalysis from "./smartOptions-depthanalysis.png";
import Flawlessapp from "./Flawlessapp.png";
import "./SmartOptions.css";
import CallTrackApi from "../Activity_Track/CallTrackApi";
import LoginPopup from "../CommonUI/LoginPopup/LoginPopup";

function SmartOptions() {
    const childRef = useRef(null);
    const [show, setShow] = useState(false);
    window.scrollTo(0, 0)
    const [welcomeData, setWelcomeSection] = useState(
        {
            title: "Automate your option trading strategies with target & stoploss",
        },
        []
    );
    const clickToggleLoginPopup = (showhide) => {
        // window.open(
        //     'https://ekyc.moneysukh.com:8443/index.aspx',
        //     '_blank'
        // );
        childRef.current.changeTogglePopup(showhide);
    }
    // CallTrackApi("AlgoBTest", window.location.href);

    return (
        <>
            <main class="SmartOptionsMain">
                <SmartOptionsWelcome data={welcomeData} />
                <SmartOptionsHowItWorks />
                <SmartOptionsOneStopSolution />
                <SmartOptionsCompleteIndex />
                <section className="SmartOptionsDepthanalysis_section">
                    <Container>
                    <Row className="align-items-center">
                    <Col md={7} sm={7}>
                        <div className="SmartOptionsDepthanalysis_content">
                            <h2> Get full in-depth analysis of open interest and PCR on your mobile</h2>
                            <a href="https://www.youtube.com/watch?v=xQqTGXoRe48&t=1s" target="_blank" className="btn learnmore_btn">Learn More </a>
                        </div>
                        </Col>
                        <Col md={5} sm={5}>
                        <div className="SmartOptionsDepthanalysis_img">
                            <img
                            className="img-fluid"
                            src={SmartOptionsDepthanalysis}
                            alt="SmartOptions"
                            />
                        </div>
                        </Col>
                    </Row>
                    </Container>
                </section>
                <section className="SmartOptionsFlawlessApp_section">
                    <Container>
                    <div class="SmartOptionsFlawlessApp_head  text-center">
                        <h2 className="section-heading"> Flawless application for<br></br> <span>option trading</span></h2>
                        <p>Analyze options with Greeks, OI, Volume, and more. Place orders directly from the <br></br>Advanced Option 
                            Chain! Perfect for those who want data, efficiency, and quick <br></br>order execution while trading online options!
                        </p>
                    </div>
                    <Row>
                    <Col md={5} sm={12}>
                        <div className="SmartOptionsFlawlessApp_img">
                            <img
                            className="img-fluid"
                            src={Flawlessapp}
                            alt="SmartOptionsFlawless"
                            />
                        </div>
                        </Col>
                    <Col md={7} sm={12}>
                        <div className="SmartOptionsFlawlessApp_list">
                            <div className="SmartOptionsFlawlessApp_group">
                                <h3>Hassle free options trading for pro traders</h3>
                            </div>
                            <div className="SmartOptionsFlawlessApp_group">
                                <h3>Trade at flat ₹10 across all segments </h3>
                            </div>
                            <div className="SmartOptionsFlawlessApp_group">
                                <h3>Free for Moneysukh clients.</h3>
                            </div>
                            <div className="SmartOptionsFlawlessApp_group">
                                <h3>No hidden charges</h3>
                            </div>
                        </div>
                        </Col>
                        
                    </Row>
                    </Container>
                </section>  
                <section class="open-account-sc"><div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="head">Open Your Account</div>
                            <div class="img-container">
                                <img className="img-fluid" src={congratulation} alt="congratulation" />
                            </div>
                            <button class="bttn" onClick={() => clickToggleLoginPopup(true)}>
                                    Get started
                                </button>
                        </div>
                    </div>
                </div>
                </section>
                <LoginPopup show={show} ref={childRef} />
            </main>
        </>
    );
}
export default SmartOptions;

